module.exports = __webpack_public_path__ + "img/visionaries-card-one.c341e87c.png";